<template>
  <div>
    <div v-if="listRole">
      <div class="row m-b-lg m-t-lg wrapper">
        <div class="col-md-12">
          <h3>
            {{ listRole.name }}
          </h3>
        </div>
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-4">
              <table class="table small m-b-xs">
                <tbody>
                <tr>
                  <td>Name</td>
                  <td>
                    <e-txt
                      type="editable"
                      :text="listRole.name"
                      @input="updateProperty($event, 'name')"
                      close-on-save="true"
                    ></e-txt>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-4">
              <table class="table small m-b-xs">
                <tbody>
                <tr>
                  <td>Active</td>
                  <td>
                    <e-txt
                    type="select"
                    :text="listRole.active"
                    :selectedValue="listRole.active ? 'true' : 'false'"
                    :options="[{val: 'false', label: 'No'}, {val: 'true', label: 'Yes'}]"
                    selectLabel="label"
                    selectValue="val"
                    @input="updateProperty($event === 'true' ? 1 : 0, 'active')"
                    close-on-save="true"
                  ></e-txt>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import EditText from '../../../Helpers/Form/EditText'
import axios from 'axios'
import { USER_ROLE_LIST_SET } from '../../../../store/mutation-types'

export default {
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({
      f: 'getFilters',
      user: 'getUser',
      listUsers: 'getUsers',
      userRoles: 'getUserRoles'
    }),
    listRole: ({$route, $store}) => $store.state.userRoleList.find(r => r.id === parseInt($route.params.id)) || {},
    clients: { get ({ listUser }) { return listUser.clients ? listUser.clients.map(c => c.id) : [] }, set () {} },
    roles: { get ({ listUser }) { return listUser.roles || [] }, set () {} }
  },
  components: {
    eTxt: EditText
  },
  mounted () {
    if (!this.f.clients) {
      this.$store.dispatch('loadFilters')
    }
    this.loaded = true
    document.title = `Admin Users: ${this.listUser.name || ''} :: PBN360 by Aphex Media`
  },
  methods: {
    updateProperty (val, prop) {
      let data = {}
      data[prop] = val

      axios.patch(`/role/${this.listUser.id}`, data)
        .then(r => {
          const listUser = r.data.data
          this.$toastr.success(`${prop} updated successfully`, 'Good')
          this.$store.commit(USER_ROLE_LIST_SET, this.listUsers.map(u => u.id === listUser.id ? listUser : u))
          this.$forceUpdate()
        })
        .catch(e => {
          this.$toastr.error(e, 'Unable to update')
        })

      return true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Admin/Role/Header.vue